import { useEffect } from "react";
import { fetchSettings, BACKEND } from "@/lib/api";

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSEO({ title, description, path }) {
  const pageKey = path === "/" ? "home" : (path || "").replace(/^\//, "").split("/")[0];

  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    const url = `https://taxipark.ge${path || window.location.pathname}`;
    setMeta("property", "og:url", url);
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [title, description, path]);

  useEffect(() => {
    fetchSettings().then((s) => {
      const ov = (s.seo || {})[pageKey];
      if (ov?.title) {
        document.title = ov.title;
        setMeta("property", "og:title", ov.title);
      }
      if (ov?.description) {
        setMeta("name", "description", ov.description);
        setMeta("property", "og:description", ov.description);
      }
      if (s.og_title) setMeta("property", "og:title", s.og_title);
      if (s.og_description) setMeta("property", "og:description", s.og_description);
      if (s.og_image_url) {
        const img = s.og_image_url.startsWith("http") ? s.og_image_url : `${BACKEND}${s.og_image_url}`;
        setMeta("property", "og:image", img);
        setMeta("name", "twitter:image", img);
      }
      setMeta("name", "robots", ov?.noindex ? "noindex, nofollow" : "index, follow");
    });
  }, [pageKey]);
}
